import Icon from "@ant-design/icons";
const User = () => (
  <svg
    t="1578904690958"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1112"
    xlink="http://www.w3.org/1999/xlink"
    width="1em"
    height="1em"
  >
    <defs>
      <style type="text/css"></style>
    </defs>
    <path
      d="M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512zM512 95.971556a415.857778 415.857778 0 0 0-308.337778 694.897777c60.302222-29.127111 38.684444-4.892444 117.191111-37.376a891.676444 891.676444 0 0 0 99.555556-44.714666l1.137778-76.458667a143.815111 143.815111 0 0 1-39.822223-94.890667c-18.773333 5.688889-25.031111-22.016-26.168888-39.480889s-10.808889-69.632 11.946666-64.853333a470.584889 470.584889 0 0 1-6.257778-83.797333 152.405333 152.405333 0 0 1 151.324445-125.155556 139.605333 139.605333 0 0 1 150.755555 125.155556 482.872889 482.872889 0 0 1-6.826666 83.797333c23.324444-4.721778 13.084444 47.957333 11.946666 64.796445s-7.395556 44.828444-26.168888 39.424a142.848 142.848 0 0 1-39.822223 94.663111l1.137778 76.060444s18.773333 10.808889 99.555556 43.975111c78.506667 32.426667 56.888889 9.614222 116.622222 38.855111A415.288889 415.288889 0 0 0 512 95.971556z"
      fill="#61CBD9"
      p-id="1113"
    ></path>
  </svg>
);

const UserIcon = (props) => <Icon component={User} {...props} />;

export default UserIcon;
